import axios from "axios";
import store from "../store";
import backend from '../router/backend'; 
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export const axiosInstance = axios.create({
  baseURL: backend.baseURL,
});

axiosInstance.interceptors.request.use(function (config) {
  NProgress.start();
  const authToken = store.state.auth.authToken;
  const selectedLang = localStorage.getItem("lang") || "de";
  const isFormData =
    typeof FormData !== "undefined" && config.data instanceof FormData;
  const headers = {
    ...(config.headers || {}),
    Authorization: `Bearer ${authToken}`,
    Accept: "application/json",
    "Accept-Language": selectedLang,
  };

  if (isFormData) {
    delete headers["Content-Type"];
    delete headers["content-type"];
  } else if (!headers["Content-Type"] && !headers["content-type"]) {
    headers["Content-Type"] = "application/json";
  }

  config.headers = headers;

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.done();
    const router = require("../router/index").default;

    // error.response null olabilir (örneğin ağ hatası), bu yüzden kontrol ekleyelim
    if (error.response) {
      switch (error.response.status) {
        case 422:
          store.commit("setErrors", error.response.data.errors);
          return Promise.reject(error); // 09.04.2026
          // return error.response; // 27.12.2021 tarihinde user/add için eklendi.

        case 401: // Unauthorized access!
          // Önce mevcut token ve kullanıcı verilerini temizle
          store.commit("auth/setUserData", null);
          localStorage.removeItem("authToken");
          localStorage.removeItem("authData");
          localStorage.removeItem("selectedFirm");

          // Kullanıcıyı Login sayfasına yönlendir, eğer zaten orada değilse
          // router.currentRoute Vue 3'te router.currentRoute.value şeklinde kullanılır.
          // Vue Router versiyonunuza göre düzeltmeniz gerekebilir.
          // Bu projede Vue 2 ve vue-router 3.x kullanıldığı varsayılıyor.
          if (router.currentRoute.name !== "Login") {
            console.log("Axios interceptor: Redirecting to Login page.");
            router.push({ name: "Login" }).catch((err) => {
              if (
                err.name !== "NavigationDuplicated" &&
                err.name !== "NavigationCancelled"
              ) {
                console.error("Router push error in 401 interceptor:", err);
              }
            });
          }

          return error.response;
        // return Promise.reject(new Error("Session expired or unauthorized. User redirected to login."));

        case 403: // Forbidden: You don't have permission!
          if (router.currentRoute.name !== "Page403") {
            router.push({ name: "Page403" });
          }
          return Promise.reject(error); // Orijinal hatayı yine de reject et

        default:
          return Promise.reject(error);
      }
    } else {
      // error.response yoksa (örneğin ağ hatası)
      console.error(
        "Axios interceptor: Network error or no response from server",
        error
      );
      return Promise.reject(error);
    }
  }
);
